module.exports = __webpack_public_path__ + "img/critical-alert-button.a74b146f.svg";